import { ReactElement } from 'react';
import BasicLayout from '../layouts/BasicLayout';
import { Outlet } from 'react-router-dom';
import MobilePortalPage from './views/MobilePortalPage';

const MobilePortalRoute = (props:any): ReactElement => {
  const data=props.loginData;
  const permissions = props.permissions;

 return (
    <BasicLayout userData={data} permissions={permissions} sidebars={props.sidebarsData}>
      <MobilePortalPage/>
      <Outlet />
    </BasicLayout>
  )
};

export default MobilePortalRoute;